import 'semantic-ui-less/semantic.less';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { AppSettingsProvider } from 'contexts/appSettings';
import { Loader } from 'semantic-ui/semantic-ui-imports';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import './config/momentConfig';
import { AuthProvider } from './contexts/auth';
import { DataProvider } from './contexts/data';
import { PromptToSignInProvider } from './contexts/promptToSignIn';

ReactDOM.render(
  <React.StrictMode>
    <AppSettingsProvider>
      <AuthProvider>
        <PromptToSignInProvider>
          <DataProvider>
            <Suspense fallback={<Loader />}>
              <App />
            </Suspense>
          </DataProvider>
        </PromptToSignInProvider>
      </AuthProvider>
    </AppSettingsProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
